import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { OptionsSource } from '../../../../core/core.models';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { CompaniesService } from '../../companies/companies.service';
import { ThirdPartyApi, ThirdPartyApiAuthentication } from '../third-party-api-auth.models';

@Component({
  selector: 'app-third-party-api-auth-form',
  templateUrl: './third-party-api-auth-form.component.html',
  styleUrls: ['./third-party-api-auth-form.component.scss']
})
export class ThirdPartyApiAuthFormComponent extends BaseFormComponent implements OnInit {
  public companies: OptionsSource;
  public apis: ValueLabel[] = [];

  constructor(
    public authService: AuthService,
    public companiesService: CompaniesService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
    ) {
      super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
     }

  ngOnInit(): void {
    this.authorities.init('CRUD_3RD_PRTY_AUTH', 'CRUD_3RD_PRTY_AUTH', 'CRUD_3RD_PRTY_AUTH', 'CRUD_3RD_PRTY_AUTH');
    this.url = `${Constants.contextPath}/third-party-auth`;
    this.prepareLookupData();
    this.prepareFormData(new ThirdPartyApiAuthentication(), (response: ThirdPartyApiAuthentication) => {
      return this.modifyResponse(response);
    });
  }

  private prepareLookupData() {
    this.apis = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(ThirdPartyApi, true), 'value', 'label');
    this.companies = this.companiesService.getCompaniesOptions();
  }

  public modifyResponse(response: ThirdPartyApiAuthentication) {
    response.breadcrumbsId = response.id;
    this.active = response.active;
    this.activeText = response.active ? 'SHARED.DEACTIVATE' : 'SHARED.ACTIVATE';
    return response;
  }

  public apiChanged = (event) => {
    this.formData.api = event.value;
  }

}
